<app-center-container
  [title]="title"
  [showClose]="true"
  (close)="close.emit()">

  @if (form) {
    <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
      <app-input-wrapper
        [control]="form.get('first_name')"
        label="{{ 'firstName' | translate }}"
        identifier="first_name">
        <input class="form_control" type="text" formControlName="first_name" name="first_name" id="first_name">
      </app-input-wrapper>
      <app-input-wrapper
        [control]="form.get('last_name')"
        label="{{ 'lastName' | translate }}"
        identifier="last_name">
        <input class="form_control" type="text" formControlName="last_name" name="last_name" id="last_name">
      </app-input-wrapper>
      @if (!authService.isSsoNoEmail) {
        <app-input-wrapper
          [control]="form.get('email')"
          label="{{ 'email' | translate }}"
          identifier="email">
          <input
            autocorrect="off"
            autocapitalize="none"
            class="form_control"
            type="email"
            formControlName="email"
            name="email"
            id="email">
        </app-input-wrapper>
      }
      @if (!authService.isSsoNoEmail || user) {
        <app-input-wrapper
          [control]="form.get('username')"
          label="{{ 'username' | translate }}"
          identifier="username">
          <input
            autocorrect="off"
            autocapitalize="none"
            class="form_control"
            type="text"
            formControlName="username"
            name="username"
            id="username">
        </app-input-wrapper>
      }
      @if (authService.isSsoNoEmail) {
        <app-input-wrapper
          [control]="form.get('sso_id')"
          label="{{ 'ssoEmployeeId' | translate }}"
          identifier="sso_id">
          <input
            autocorrect="off"
            autocapitalize="none"
            class="form_control"
            type="text"
            formControlName="sso_id"
            name="sso_id"
            id="sso_id">
        </app-input-wrapper>
      }
      <app-input-wrapper
        [control]="form.get('phone_number')"
        [hasPlaceholderOffset]="true"
        label="{{ 'phone' | translate }}">
        <ngx-mat-intl-tel-input
          class="form_control"
          [preferredCountries]="['us']"
          [enablePlaceholder]="true"
          [enableSearch]="true"
          formControlName="phone_number">
        </ngx-mat-intl-tel-input>
      </app-input-wrapper>
      <app-input-wrapper
        [control]="form.get('offices')"
        label="{{ 'office' | translate }}">
        <mat-select
          multiple
          class="form_control"
          formControlName="offices"
          disableOptionCentering
          panelClass="dropdown"
          name="offices"
          aria-label="{{ 'office' | translate }}">
          @for (office of offices; track office.id) {
            <mat-option [value]="office.id">
              {{ office.name }}
            </mat-option>
          }
        </mat-select>
      </app-input-wrapper>
      <app-input-wrapper
        [control]="form.get('employeeGroup')"
        label="{{ 'employeeGroup' | translate }}">
        <mat-select
          class="form_control"
          formControlName="employeeGroup"
          disableOptionCentering
          panelClass="dropdown"
          name="group"
          aria-label="{{ 'employeeGroup' | translate }}">
          @for (group of employeeGroups; track group.id) {
            <mat-option [value]="group.value">
              {{ group.name | translate | titlecase }}
            </mat-option>
          }
        </mat-select>
      </app-input-wrapper>
      <br>
      <button class="button button--primary form_button" type="submit" [disabled]="!form.valid || !form.dirty">
        <span class="regular">{{ 'done' | translate }}</span>
      </button>
    </form>
  }

</app-center-container>

@if (isLoading) {
  <app-loader></app-loader>
}
